import { RulesResponse } from "~/endpoints/rules/types";
import { useTfSimpleVaspList } from "~/endpoints/trustFramework";
import { SimpleListVASPInput } from "~/endpoints/trustFramework/types";
import { AdvancedRule } from "~/templates/rules/AdvancedRules/types";
import { VASP } from "~/types/vaspid";

export function useAllVASPs(query: string): [VASP[] | null, boolean] {
  const variables: SimpleListVASPInput | null = {
    includeUncheckedVASPs: false,
    all: true,
    listingType: "all",
    q: query.length > 2 ? query : "",
    fields: ["did", "name", "website", "logo", "jurisdictions, subsidiaries"],
  };

  const { data: dataTfVaspList, isLoading } = useTfSimpleVaspList(variables);

  const vasps = dataTfVaspList?.vasps || null;
  return [vasps, isLoading];
}

// I got this piece of code from this library https://github.com/sindresorhus/array-move
// We can see there an explanation of how this works
// I choose to copy the functions instead of adding the library because it is just 2 methods

export function arrayMoveImmutable(array: Array<any>, fromIndex: number, toIndex: number) {
  array = [...array];
  arrayMoveMutable(array, fromIndex, toIndex);
  return array;
}

function arrayMoveMutable(array: Array<any>, fromIndex: number, toIndex: number) {
  const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

    const [item] = array.splice(fromIndex, 1);
    array.splice(endIndex, 0, item);
  }
}

export function buildRulesObject(responseRules: RulesResponse[], vaspDID: string) {
  if (responseRules.length === 0) {
    return {
      rulesOption: "no-rules",
      rules: [],
    };
  }

  if (responseRules.filter((rule) => rule.actionRule === "NOT_READY").length) {
    return {
      rulesOption: "not-ready",
      rules: [],
    };
  }

  const [ruleToApproveAll] = responseRules.filter((rule) => rule.ruleCheck === "ALL");

  if (ruleToApproveAll) {
    return {
      rulesOption: "basic",
      rules: [],
    };
  }

  if (!ruleToApproveAll) {
    const rulesArray: AdvancedRule[] = [];

    responseRules.forEach((responseRule) => {
      if (responseRule.ruleCheck !== "ALL") {
        const newRules: AdvancedRule = {
          id: responseRule.id,
          actionRule: responseRule.actionRule,
          ruleCheck: responseRule.ruleCheck,
          ruleValue: responseRule.ruleValue,
          vaspDID: vaspDID,
          isBlank: false,
          isNew: false,
          source: responseRule.source,
          vasps: responseRule.vasps,
          jurisdictions: responseRule.jurisdictions,
        };
        rulesArray.push(newRules);
      }
    });
    return {
      rulesOption: "advanced",
      rules: rulesArray,
    };
  }

  return {
    rulesOption: "no-rules",
    rules: [],
  };
}
